<template>
  <div>
    <Modal v-model="show" title="剔除容器" width="600">
      <Alert show-icon type="error" v-if="errorMsg">{{ errorMsg }}</Alert>
      <Alert type="warning" show-icon>确定把容器从集群中剔除吗？</Alert>
      <div v-if="showDeleteContainerBtn">
        同时销毁容器
        <RadioGroup v-model="is_delete_container">
          <Radio label="yes" border>是</Radio>
          <Radio label="no" border>否</Radio>
        </RadioGroup>
      </div>
      <div slot="footer">
        <Button type="error" @click="submit" :loading="submitting">剔除</Button>
        <Button @click="show = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { clusterExcludingContainer } from '@/api/container/cluster'

export default {
  name: 'excluding-container',
  data () {
    return {
      show: false,
      cluster_id: '',
      container_id: '',
      showDeleteContainerBtn: true,
      is_delete_container: 'no',
      submitting: false,
      errorMsg: null
    }
  },
  methods: {
    showModal (clusterId, containerId, showDeleteContainerBtn = true) {
      this.showDeleteContainerBtn = showDeleteContainerBtn
      this.is_delete_container = 'no'
      this.cluster_id = clusterId
      this.container_id = containerId
      this.show = true
    },
    submit () {
      let reqData = {
        container_id: this.container_id,
        is_delete_container: this.is_delete_container === 'yes'
      }
      this.submitting = true
      this.errorMsg = null
      clusterExcludingContainer(this.cluster_id, reqData).then(res => {
        this.$Notice.success({title: '操作成功'})
        this.$emit('callback')
        this.show = false
        this.submitting = false
      }).catch(res => {
        this.submitting = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
          this.errorMsg = res.response.data
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
